import React from 'react';
import { useState, useEffect } from 'react';
import { IDwellTimeFilter, EStatisticsInterval, EStatisticsDateType } from '../../../../../reducers/data';
import getDwellStats from '../../../../../reducers/api/getDwellStats';
import Loader from '../../Loader';
import { useLingui } from '@lingui/react';
import { IGraphContentData } from '../../../../interfaces/types';
import XYGraph from './XYGraph';
import { parseGraphData, parseGraphDataOverlay } from '../../../../helpers/index';
import { t, Trans } from '@lingui/macro';

interface IProps {
    filter: IDwellTimeFilter
}

const GraphDwellTime = (props: IProps) => {
    const lingui = useLingui()

    const [loading, setLoading] = useState(false)
    const [rawData, setRawData] = useState<any[]>([])
    const [overlayMode, setOverlayMode] = useState(false)
    const [graphData, setGraphData] = useState<IGraphContentData>({
        series: [],
        categories: []
    })

    useEffect(() => {
        setLoading(true)
        let isMounted = true

        getDwellStats(props.filter)
            .then(res => {
                if(isMounted) {
                    setLoading(false)
                    setRawData(res ? res : [])
                }
            })
            .catch(e => {
                if(isMounted) {
                    setLoading(false)
                    setRawData([])
                }
            })
        return () => { isMounted = false }
    }, [props.filter])

    useEffect(() => {
        if (overlayMode) {
            setGraphData(parseGraphDataOverlay(rawData, lingui.i18n))
        } else {
            setGraphData(parseGraphData(rawData, lingui.i18n))
        }
    }, [rawData, overlayMode, lingui.i18n])

    let graphTitle = t`Multi`
    let graphInterval = EStatisticsInterval.min60;
    let isTime = true;

    if(props.filter.dateType === EStatisticsDateType.week) {
        graphInterval = EStatisticsInterval.day;
    } else if (props.filter.dateType === EStatisticsDateType.month) {
        graphInterval = EStatisticsInterval.day;
    } else if (props.filter.dateType === EStatisticsDateType.year) {
        graphInterval = EStatisticsInterval.month;
    }
    let yTitle = t`Strávený čas`

    // In overlay mode force hour-of-day interval so X axis shows HH:mm
    const effectiveInterval = overlayMode ? EStatisticsInterval.min60 : graphInterval

    return (
        <>
            <Loader value={loading}/>

            <div className="grid align-center pdb-10">
                <div className="col_fill" />
                <div className="col_default">
                    <div className="btn_switch" role="group" aria-label={t`Režim zobrazenia`}>
                        <button
                            type="button"
                            className={`btn_switch--item${!overlayMode ? ' active' : ''}`}
                            onClick={() => setOverlayMode(false)}
                            title={t`Sériový režim – dni za sebou`}
                        >
                            <svg className="sico wh16" style={{marginRight: 4}}><use xlinkHref="/assets/layout/icons.svg#s_chart_line" /></svg>
                            <Trans>Séria</Trans>
                        </button>
                        <button
                            type="button"
                            className={`btn_switch--item${overlayMode ? ' active' : ''}`}
                            onClick={() => setOverlayMode(true)}
                            title={t`Prekryvný režim – dni na rovnakej osi`}
                        >
                            <svg className="sico wh16" style={{marginRight: 4}}><use xlinkHref="/assets/layout/icons.svg#s_chart_area" /></svg>
                            <Trans>Prekryv</Trans>
                        </button>
                    </div>
                </div>
            </div>

            <XYGraph
                graphTitle={graphTitle}
                graphData={graphData}
                interval={effectiveInterval}
                isTime={isTime}
                yTitle={yTitle}
                overlayMode={overlayMode}
            />
        </>
    )
};

export default GraphDwellTime
